import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../../../main/components/Modal';
import Steps from './Steps';
import GlobalContext from '../../../main/utils/GlobalContext';

const ModalCreateClass = ({ visible = false, onClose = () => {} }) => {
  const { locales } = useContext(GlobalContext);
  const {
    classroom: { currentStep },
  } = useSelector((state) => state);

  const {
    classroom: { setCurrentStepIndex },
  } = useDispatch();

  const handleClose = () => {
    onClose();
    setCurrentStepIndex(0);
  };

  return (
    <Modal
      isOpen={visible}
      onClose={handleClose}
      title={locales.admin.createNewClass}
    >
      <Steps stepIndex={currentStep} onCancel={handleClose} locales={locales} />
    </Modal>
  );
};

ModalCreateClass.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
};
export default ModalCreateClass;
